<!-- Button -->
<button
    class="relative flex items-center justify-center w-10 h-10 bg-card rounded-md"
    mat-icon-button
    [matMenuTriggerFor]="languages">
    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: activeLang}"></ng-container>
</button>

<!-- Language menu -->
<mat-menu
    [xPosition]="'before'"
    #languages="matMenu">
    @for (lang of availableLangs; track $index) {
        <ng-container>
            
            <button
                mat-menu-item
                (click)="setActiveLang(lang)">
                <span class="flex items-center">
                    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: lang}"></ng-container>
                    <span class="mx-2">{{ getLabel(lang) }}</span>
                </span>
            </button>
        </ng-container>
    }
</mat-menu>

<!-- Flag image template -->
<ng-template
    let-lang
    #flagImage>
    <span class="relative w-6 rounded-sm overflow-hidden">
        <img
            class="w-full"
            [src]="'assets/images/flags/' + flagCodes[lang] + '.svg'"
            [alt]="'Flag image for ' + lang">
    </span>
</ng-template>
